import { Config } from './interface';
import { CrmListsDependencies } from '@galaxy/crm/static';

export class ListsDependencies {
  constructor(private readonly config: Config) {}

  build(): CrmListsDependencies {
    return {
      canStartManualAutomation$: this.config.canStartManualAutomation$,
    };
  }

  static build(config: Config): CrmListsDependencies {
    const instance = new ListsDependencies(config);
    return instance.build();
  }
}
